import React, { Component, createContext, createRef } from 'react';
import { node, string, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import styles from './HeroWrapper.css';

const { Provider, Consumer } = createContext();
const cx = classnames.bind(styles);

class HeroWrapper extends Component {
  static propTypes = {
    children: node.isRequired,
    className: string,
    colorScheme: oneOf(['lb01', 'pb01', 'pb02']),
    youtubeVideoId: string,
    videoSrc: string,
    thumbnail: string,
  };

  static defaultProps = {
    colorScheme: 'lb01'
  };

  state = {
    isPlaying: false,
    youtubeLoaded: false
  }

  videoRef = createRef();
  player = null;

  componentDidMount = () => {
    const { youtubeVideoId, videoSrc } = this.props;

    if(youtubeVideoId) { 
      this.loadIframeApi()
      .then(this.verifyLoadedApi)
      .then(this.initializePlayer);
    }

    if(videoSrc) {
      const video = this.videoRef.current;

      video.onended = this.onVideoEnd;
    }
  }

  initializePlayer = YT => {
    const { youtubeVideoId } = this.props;
    const container = this.videoRef.current;
    
    this.player = new YT.Player(container, {
      videoId: youtubeVideoId,
      playerVars: {
        rel: 0,
        controls: 0,
        autoplay: 0,
        modestbranding: 0,
        fs: 0
      },
      events: {
        onReady: this.onYoutubeLoad,
        onStateChange: this.onVideoEnd
      }
    });
  }

  verifyLoadedApi = () => {
    return new Promise(resolve => {
      if (window.YT && window.YT.loaded) {
        resolve(window.YT);
      }
  
      window.onYouTubeIframeAPIReady = () => {
        resolve(window.YT);
      };
    });
  }

  async loadIframeApi() {
    const tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.querySelector('script');
    return await firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  onYoutubeLoad = () => this.setState({ youtubeLoaded: true });

  onPlayVideo = () => {
    const { youtubeVideoId } = this.props;

    youtubeVideoId
      ? this.player.playVideo()
      : this.videoRef.current.play();

    this.setState({ isPlaying: true });
  }

  onClickContainer = () => {
    const { youtubeVideoId } = this.props;

    youtubeVideoId
      ? this.player.stopVideo()
      : this.videoRef.current.pause();

    this.setState({ isPlaying: false });
  }

  onVideoEnd = (e) => {
    if (e.data === 0) {
      this.setState({ isPlaying: false });
    } 
  };

  getBgImagePath = () => {
    const { youtubeVideoId, thumbnail } = this.props;

    return youtubeVideoId && !thumbnail
      ? `http://img.youtube.com/vi/${youtubeVideoId}/maxresdefault.jpg`
      : `${thumbnail}`;
  }

  renderSrcVideo = () => {
    const { videoSrc } = this.props;

    return (
      <div className={styles.videoBackground}>
        <video className={styles.videoSrc} ref={this.videoRef}>
          <source src={videoSrc} type="video/mp4" />
        </video>
      </div>
    );
  }

  render () {
    const { isPlaying, youtubeLoaded } = this.state;
    const { children, className, colorScheme, youtubeVideoId, videoSrc, thumbnail } = this.props;
    const onPlayVideo = !youtubeLoaded && youtubeVideoId 
      ? () => console.log('youtube is being loaded')
      : this.onPlayVideo;

    return (
      <div
        className={cx('wrapper', colorScheme, className, { isPlaying })}
        style={(thumbnail || youtubeVideoId) && { backgroundImage: `url(${this.getBgImagePath()})`}}
        onClick={isPlaying ? this.onClickContainer : null}
        id="hero-wrapper"
      >
        {youtubeVideoId && <div className={styles.videoBackground} ref={this.videoRef} />}
        {videoSrc && this.renderSrcVideo()}
        {(youtubeVideoId || videoSrc) && <div className={styles.overlay} />}
        <Provider value={{ playVideo: onPlayVideo }}>
          {children}
        </Provider>
      </div>
    );
  }
}

export { Consumer };
export default HeroWrapper;



// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/HeroWrapper/HeroWrapper.js